import MealAccordion from 'components/base/accordion';
import { OrderBrandMeals, OrderType } from 'models/order.model';
import React, { FC, useMemo } from 'react';
import { getNameFromOrder, getUserName } from 'utils/functions';

type Props = {
  order: OrderType;
};

const OrderDetailsBody: FC<Props> = ({ order }) => {
  const fullName = getNameFromOrder(order);
  const isGroupOrder = order?.calculated_order?.is_group_order;

  const brandMeals = useMemo(() => {
    return new OrderBrandMeals(order).meals;
  }, [order]);

  const subGroupOrder = useMemo(() => {
    return new OrderBrandMeals(order).subOrders;
  }, [order]);

  return (
    <div className='order-body'>
      <div>
        {isGroupOrder && (
          <span className='pl-4 text-xs'>
            {1 + '.'} Host - {fullName}
          </span>
        )}
      </div>

      {brandMeals.map((item, idx) => (
        <div
          key={idx}
          className={`${brandMeals.length - 1 === idx ? '' : ' border-b border-gray-border '}`}>
          <MealAccordion item={item} />
        </div>
      ))}

      {isGroupOrder &&
        subGroupOrder.map((subOrder, idx) => (
          <>
            <span className='pl-4 text-sm'>
              {idx + 2 + '.'} {getUserName(subOrder.user)}
            </span>
            {subOrder.brandMeals.map((subOrderMeal, i) => {
              const index = `${i}-${getUserName(subOrder.user)}`;
              return (
                <div
                  key={index}
                  className={`mx-6 ${
                    subOrderMeal.meals.length - 1 === idx ? '' : 'border-b border-gray-border '
                  }`}>
                  <MealAccordion item={subOrderMeal} />
                </div>
              );
            })}
          </>
        ))}
    </div>
  );
};

export default OrderDetailsBody;
